'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Td: ()=>Td
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_Td_variants_cjs_namespaceObject = require("./Td.variants.cjs");
const index_cjs_namespaceObject = require("../TBody/index.cjs");
const external_Tr_index_cjs_namespaceObject = require("../Tr/index.cjs");
const external_TrDrawer_index_cjs_namespaceObject = require("../TrDrawer/index.cjs");
const external_TrDrawerContent_index_cjs_namespaceObject = require("../TrDrawerContent/index.cjs");
const external_cleanTableProps_cjs_namespaceObject = require("../cleanTableProps.cjs");
const external_Table_index_cjs_namespaceObject = require("../Table/index.cjs");
const external_utils_index_cjs_namespaceObject = require("../../../utils/index.cjs");
const Td = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(({ children, className, contentClassName, placeholder = false, ...props }, ref)=>{
    const { bordered: tableBordered, firstColumnSticky, striped: tableStriped, cellLineClamp: tableCellLineClamp, cellMaxWidth: tableCellMaxWidth, cellSize: tableCellSize, cellTextWrap: tableCellTextWrap, cellWordBreak: tableCellWordBreak, maxColumns } = (0, external_Table_index_cjs_namespaceObject.useTableContext)();
    const { striped: tableBodyStriped, cellLineClamp: tableBodyCellLineClamp, cellMaxWidth: tableBodyCellMaxWidth, cellSize: tableBodyCellSize, cellTextWrap: tableBodyCellTextWrap, cellWordBreak: tableBodyCellWordBreak } = (0, index_cjs_namespaceObject.useTableBodyContext)();
    const { striped: tableRowStriped, cellLineClamp: tableRowCellLineClamp, cellMaxWidth: tableRowCellMaxWidth, cellSize: tableRowCellSize, cellTextWrap: tableRowCellTextWrap, cellWordBreak: tableRowCellWordBreak, isGroupHeader } = (0, external_Tr_index_cjs_namespaceObject.useTableRowContext)();
    const { isDrawer, isOpen } = (0, external_TrDrawer_index_cjs_namespaceObject.useTableRowDrawerContext)();
    const { isDrawerContent } = (0, external_TrDrawerContent_index_cjs_namespaceObject.useTableRowDrawerContentContext)();
    const { lineClamp: cellLineClamp, maxWidth: cellMaxWidth, size: cellSize, textWrap: cellTextWrap, wordBreak: cellWordBreak } = props;
    const lineClamp = cellLineClamp ?? tableRowCellLineClamp ?? tableBodyCellLineClamp ?? tableCellLineClamp;
    const maxWidth = cellMaxWidth ?? tableRowCellMaxWidth ?? tableBodyCellMaxWidth ?? tableCellMaxWidth;
    const size = cellSize ?? tableRowCellSize ?? tableBodyCellSize ?? tableCellSize;
    const textWrap = cellTextWrap ?? tableRowCellTextWrap ?? tableBodyCellTextWrap ?? tableCellTextWrap;
    const wordBreak = cellWordBreak ?? tableRowCellWordBreak ?? tableBodyCellWordBreak ?? tableCellWordBreak;
    const rowStriped = tableRowStriped ?? tableBodyStriped ?? tableStriped;
    const styles = (0, external_Td_variants_cjs_namespaceObject.tdVariants)({
        ...props,
        size,
        firstColumnSticky,
        rowStriped,
        tableBordered,
        textWrap,
        lineClamp,
        maxWidth,
        wordBreak,
        isDrawer,
        isOpen,
        isGroupHeader
    });
    const cleanedProps = (0, external_cleanTableProps_cjs_namespaceObject.cleanTableProps)(props);
    let colSpan;
    if (!isDrawerContent || isGroupHeader || placeholder) {
        if (!isDrawerContent && isGroupHeader && !placeholder) colSpan = maxColumns;
    } else colSpan = maxColumns - 1;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("td", {
        className: (0, external_utils_index_cjs_namespaceObject.cn)(styles.base(), className),
        colSpan: colSpan,
        ...cleanedProps,
        ref: ref,
        children: isDrawerContent ? children : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
            className: (0, external_utils_index_cjs_namespaceObject.cn)(styles.content(), contentClassName),
            children: children
        })
    });
});
exports.Td = __webpack_exports__.Td;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Td"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
